var _excluded = ["className", "children"],
    _excluded2 = ["placement"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { chakra, forwardRef, omitThemingProps, StylesProvider, useMultiStyleConfig, useStyles } from '@chakra-ui/system';
import { __DEV__, cx } from '@chakra-ui/utils';
import * as React from 'react';
var {
  Provider,
  Consumer
} = /*#__PURE__*/React.createContext(undefined);
export { Provider as RTableProvider, Consumer as RTableConsumer };
export var ResponsiveTable = forwardRef((props, ref) => {
  var styles = useMultiStyleConfig('ResponsiveTable', props);

  var _omitThemingProps = omitThemingProps(props),
      {
    className,
    children
  } = _omitThemingProps,
      tableProps = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded);

  return /*#__PURE__*/React.createElement(Provider, {
    value: {}
  }, /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(chakra.table, _extends({
    __css: styles.table,
    className: cx('responsive-chakra-table', className),
    ref: ref,
    role: "table"
  }, tableProps), children)));
});

if (__DEV__) {
  ResponsiveTable.displayName = 'ResponsiveTable';
}
/* -------------------------------------------------------------------------------------------------
 * TableCaption
 * -----------------------------------------------------------------------------------------------*/


export var RTableCaption = forwardRef((props, ref) => {
  var {
    placement = 'bottom'
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded2);

  var styles = useStyles();
  return /*#__PURE__*/React.createElement(chakra.caption, _extends({}, rest, {
    __css: _extends({}, styles.caption, {
      captionSide: placement
    }),
    ref: ref
  }));
});

if (__DEV__) {
  RTableCaption.displayName = 'RTableCaption';
}
/* -------------------------------------------------------------------------------------------------
 * TableFooter: Tfoot
 * -----------------------------------------------------------------------------------------------*/


export var RTfoot = forwardRef((props, ref) => {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(chakra.tfoot, _extends({}, props, {
    __css: styles.tfoot,
    ref: ref
  }));
});

if (__DEV__) {
  RTfoot.displayName = 'RTfoot';
}
//# sourceMappingURL=ResponsiveTable.js.map